module.exports = __webpack_public_path__ + "static/media/cf-grads.5954ae6b.jpg";